export const ADD_NEW_FAMILY_MEMBER = 'ADD_NEW_FAMILY_MEMBER'
export const ADD_NEW_MEMBER_DETAILS = 'ADD_NEW_MEMBER_DETAILS'
export const ADD_NEW_MEMBER_REQUESTED = 'ADD_NEW_MEMBER_REQUESTED'
export const CLEAR_ADD_NEW_MEMBER_ERROR = 'CLEAR_ADD_NEW_MEMBER_ERROR'
export const ADD_NEW_MEMBER_RECEIVED = 'ADD_NEW_MEMBER_RECEIVED'
export const ADD_NEW_MEMBER_ERRORS = 'ADD_NEW_MEMBER_ERRORS'
export const SHOW_MEMBER = 'SHOW_MEMBER'
export const GRANT_PERMISSION_REQUESTED = 'GRANT_PERMISSION_REQUESTED'
export const DENY_PERMISSION_RECEIVED = 'DENY_PERMISSION_RECEIVED'
export const DENY_PERMISSION_REQUESTED = 'DENY_PERMISSION_REQUESTED'
export const GRANT_PERMISSION_RECEIVED = 'GRANT_PERMISSION_RECEIVED'
export const REQUEST_PERMISSION_REQUESTED = 'REQUEST_PERMISSION_REQUESTED'
export const REQUEST_PERMISSION_RECEIVED = 'REQUEST_PERMISSION_RECEIVED'
export const PERMISSIONS_REQUESTED_DEFFERED = 'PERMISSIONS_REQUESTED_DEFFERED'
export const ADD_PERMISSIONS_NEW_MEMBER = 'ADD_PERMISSIONS_NEW_MEMBER'
export const OPTIONAL_DOCTOR_SELECTED = 'OPTIONAL_DOCTOR_SELECTED'
export const PERSONAL_DOCTOR_DETAILS_REQUESTED =
  'PERSONAL_DOCTOR_DETAILS_REQUESTED'
export const PERSONAL_DOCTOR_DETAILS_RECEIVED =
  'PERSONAL_DOCTOR_DETAILS_RECEIVED'
export const CHOOSE_PERSONAL_DOCTOR_REQUESTED =
  'CHOOSE_PERSONAL_DOCTOR_REQUESTED'
export const CHOOSE_PERSONAL_DOCTOR_RECEIVED = 'CHOOSE_PERSONAL_DOCTOR_RECEIVED'

export const SHOW_REQUEST_MEMBER_PERMISSIONS = 'SHOW_REQUEST_MEMBER_PERMISSIONS'
export const SHOW_GRANT_MEMBER_PERMISSIONS = 'SHOW_GRANT_MEMBER_PERMISSIONS'

export const NAVIGATION_FROM_CHAT_STARTED = 'NAVIGATION_FROM_CHAT_STARTED'
export const NAVIGATION_FROM_CHAT_FINISHED = 'NAVIGATION_FROM_CHAT_FINISHED'
export const MEMBER_WAS_ADDED_FROM_CHAT = 'MEMBER_WAS_ADDED_FROM_CHAT'

export const UPDATE_GRANT_PERMISSION_REQUESTED =
  'UPDATE_GRANT_PERMISSION_REQUESTED'
export const UPDATE_GRANT_PERMISSION_NO_TOGGLE_REQUESTED =
  'UPDATE_GRANT_PERMISSION_NO_TOGGLE_REQUESTED'
export const UPDATE_GRANT_PERMISSION_RECEIVED =
  'UPDATE_GRANT_PERMISSION_RECEIVED'
export const DETACH_MEMBER_REQUESTED = 'DETACH_MEMBER_REQUESTED'
export const DETACH_MEMBER_RECEIVED = 'DETACH_MEMBER_RECEIVED'
export const RESEND_PENDING_INVITATION_REQUESTED =
  'RESEND_PENDING_INVITATION_REQUESTED'
export const RESEND_PENDING_INVITATION_RECEIVED =
  'RESEND_PENDING_INVITATION_RECEIVED'
export const UPDATE_REQUEST_PERMISSION_REQUESTED =
  'UPDATE_REQUEST_PERMISSION_REQUESTED'
export const UPDATE_REQUEST_PERMISSION_RECEIVED =
  'UPDATE_REQUEST_PERMISSION_RECEIVED'
export const REJECT_FAMILY_PLAN = 'REJECT_FAMILY_PLAN'
export const REJECT_FAMILY_PLAN_CONTACT_SUPPORT =
  'REJECT_FAMILY_PLAN_CONTACT_SUPPORT'
export const REJECT_FAMILY_PLAN_CONTINUE = 'REJECT_FAMILY_PLAN_CONTINUE'
export const INIT_KIDS_APP = 'INIT_KIDS_APP'
